module.exports = __webpack_public_path__ + "aefd54f18513341ce86c6b9f25564e66.jpg";